import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import classnames from 'classnames';
import { ScanQrCode } from '@liepin/publicLogin';
import styled from './index._less';
import ImgQrcodeGuide from '../../image/qrcode-guide.png';
import SvgComplete from '../../image/complete.svg';
import useLogin from '../../hooks/use-login';


export default () => {

  const { isModal, loginIndexMark, loginSuccess } = useLogin();
  const [status, setStatus] = useState('0'); // 0登录前；1扫码成功；2二维码过期（过期、取消登录）3登录成功（跳转页面）
  const $scanQrCodeWrap = `qrcode-img-container-${loginIndexMark}`;

  useEffect(() => {

    const qrCodeLogin = new ScanQrCode({
      wrap: `#${$scanQrCodeWrap}`, // 二维码挂载DOM的CSS选择器
      tenantId: 'liepin', // 租户ID
      success: (data) => {
        // 服务端返回url时走服务端跳转，不返回时走前端处理逻辑
        const { qrExt } = data;
        if (qrExt && qrExt.biz && qrExt.biz.url) {
          window.location.href = qrExt.biz.url
        } else {
          loginSuccess(data);
        }
      },
      error: (error) => {
        setStatus('0');
        error.msg && message.error(error.msg);
      }, // 失败
      scanSuccess: () => {
        setStatus('1');
      }, // 扫描成功回调
      scanSuccessHTML: '', // 二维码扫描成功展示HTML片段, 不自定义的原因是不支持jsx如果一个页面多个登录模块事件绑定会有问题
      expireHTML: '', // 二维码过期展示HTML片段
      expire: () => {
        setStatus('0');
      }, // 二维码过期
    });
  
    // 获取二维码图片
    qrCodeLogin.scanQrCodeLogin({
      businessId: '1100100019', // 业务ID -- 必填
      appId: '6dp2Re4xQVd69gSD', // 应用Id -- 非必填
    });
    
    return () => {
      qrCodeLogin.clear();
    }

  }, [loginSuccess, $scanQrCodeWrap])

  return (
    <>
      <div className={ classnames("login-container", { 'login-container-modal': isModal, 'login-container-component': !isModal }) }>
        <div className="qrcode-status">
          <div style={{ display: status === '0' ? 'block' : 'none' }} className="qrcode-status-0">
            <div className='qrcode-img'>
              <div id={ $scanQrCodeWrap } className='qrcode-img-container'/>
              <img className='qrcode-img-guide' src={ ImgQrcodeGuide } alt="" />
            </div>
            <div className="qrcode-text">
              <div>打开<span>猎聘App</span></div>
              <div>在「我的」页面顶部打开扫一扫</div>
            </div>
          </div>
          <div style={{ display: status === '1' ? 'block' : 'none' }} className="qrcode-status-1">
            <div className="qrcode-success">
              <SvgComplete />
              <div>扫描成功</div>
            </div>
            <div className="qrcode-success-tips">请在手机上确认登录</div>
          </div>
        </div>
      </div>
      <style jsx>{ styled }</style>
    </>
  )
}
